exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes MoveUpDown {\n  0% {\n    bottom: 0; }\n  50% {\n    bottom: 100px; }\n  100% {\n    bottom: 0; } }\n\n.top-spacer {\n  width: 100%;\n  padding: 12vh 0; }\n\n.pointing-down {\n  width: 44%;\n  margin: 50px 0 0 25%;\n  animation: MoveUpDown 1s linear infinite;\n  position: relative; }\n\n.error-sub-text {\n  font-size: 4vh; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/routes/scanticket/scanticket.component.scss
// module id = ../../../../../src/app/routes/scanticket/scanticket.component.scss
// module chunks = main